import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import ClubCardInfo from 'www/vue_components/common/Club/components/core/ClubCardInfo/ClubCardInfo.vue'

const el = document.getElementById('vue-club-card-info')

if (el) {
  new Vue({
    el,
    vuetify,
    render: h => h(ClubCardInfo),
  })
}
